import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { format } from 'date-fns';
import { UI_DATE_FORMAT_SHORT } from 'lib/constants';
import React from 'react';
import { FindingHistory } from 'store/assessments/types';

interface Props {
  history?: FindingHistory[];
  onPress: () => void;
}

export const HistoryField: React.FC<Props> = ({ history, onPress }) => {
  const historyCopy = history?.slice();
  const firstItem = historyCopy?.shift();
  const lastItem = historyCopy?.reverse().find((item) => item.status);

  const identifiedText = firstItem?.ts
    ? `Identified ${format(
        new Date(firstItem.ts * 1000),
        UI_DATE_FORMAT_SHORT,
      )}`
    : 'Newly Identified';

  const lastStatusText =
    lastItem?.status && lastItem.ts
      ? `${lastItem.status.name} ${format(
          new Date(lastItem.ts * 1000),
          UI_DATE_FORMAT_SHORT,
        )}`
      : '';

  return (
    <CardRow
      icon={ICONS.ClockRotateLeftLight}
      label={identifiedText}
      label2={lastStatusText}
      label2NumberOfLines={1}
      onPress={firstItem ? onPress : undefined}
      style={{ flex: 1 }}
      contentStyle={{ paddingVertical: 0 }}
    />
  );
};
